import { Injectable } from '@angular/core';
import { RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { HttpClient } from '../_services/global-http.service';
import { ReportRow, VehicleCheckReportPaginationApi, VehicleCheckReportParams } from '../_models/vehicle-check';
import { environment } from 'environments/environment';


@Injectable()
export class ReportsService {
  apiHostVC = environment.vehicleCheckApiHost;

  constructor(private http: HttpClient) {
  }

  public getDepotReport(id: number, params: VehicleCheckReportParams) {
    const _paramType = params.type;
    const _paramStartDate = params.start_date;
    const _paramEndDate = params.end_date;

    const reportUrls = {
      STD: 'depot_report',
      AUD: 'depot_report',
      HND: 'depot_report',
      DRV: 'depot_report',
      DMG: 'depot_damages',
      GTC: 'depot_gatecheck',
      VEH: 'depot_damaged_vehicles',
      NOT: 'depot_notice_letters'
    };

    const url = `${this.apiHostVC}/api/${reportUrls[params.type]}/${id}/`;
    if (params.type === 'NOT') {
      delete params.type;
      delete params.start_date;
      delete params.end_date;
    }
    // if (params.type === 'DMG' || params.type === 'GTC' || params.type === 'NOT')
    if (params.type === 'GTC') { // This Needs to be removed / fixed in the API.
      delete params.type;
    }
    // Switch out the sorting order asending/descending to match django ordering flags
    // Angular mat table ordering options are 'asc'
    if (params.orderingDirection === 'desc') {
      params.orderingDirection = '-';
    } else { // asc
      params.orderingDirection = '';
    }
    params.ordering = params.orderingDirection + params.ordering;
    if (params.ordering === 'date' || params.ordering === '-date') {
      const _dateTime = params.orderingDirection + 'date,' + params.orderingDirection + 'time';
      params.ordering = _dateTime;
    }
    delete params.orderingDirection;

    return this.http.get(url, { params: params }, true);
  }

  public getReportDetails(id: number, reportType: string, generatePdf?: boolean) {
    const reportUrls = {
      STD: 'report_details',
      AUD: 'report_details',
      HND: 'report_details',
      DRV: 'report_details',
      GTC: 'gatecheck_details',
      NOT: 'notice_letter'
    };
    const url = `${this.apiHostVC}/api/${reportUrls[reportType]}/${id}/?pdf=${generatePdf}`;
    const _reponseType = generatePdf ? { responseType: 3 } : null;
    return this.http.get(url, _reponseType, true);
  }

  public getReportDamageHistory(reportId: number) {
    const url = `${this.apiHostVC}/api/report_damage_history/${reportId}/`;
    return this.http.get(url, null, true);
  }

  public getVorPdf(id: number) {
    const url = `/api/vor_pdf/${id}/`;
    // 2 = BufferArray
    return this.http.get(url, { responseType: 3 });
  }

  public getReportPdf(id: number, extraParams?: string) {
    const extAppKey: string = environment.externalAppKeys.dpd;
    const url = `${this.apiHostVC}/api/gen_pdf/?report=${id}${extraParams ? '&' + extraParams : ''}`;
    // 2 = BufferArray
    return this.http.get(url, { responseType: 3 }, true, { 'Authorization': extAppKey });
  }

  /*
  * Endpoint for producing a PDF report of a vehicles unfixed damage
  */
  public getUnfixedDamagesPdf(vehicleReg: string) {
    const url = `${this.apiHostVC}/api/unfixed_damages_report/?vehicle=${vehicleReg}`;
    // 2 = BufferArray
    return this.http.get(url, { responseType: 3 }, true);
  }

  /*
  * Endpoint for producing a CSV report
  */
  public getCsvReport(url: string) {
    // const url = `/api/unfixed_damages_report/?vehicle=${vehicleReg}`;
    // 2 = BufferArray
    return this.http.get(`${this.apiHostVC + url}`, null, true, null, false);
  }


  getAuditSurveyReports(params: any) {
    return this.http.get('/api/audit_survey_report/', { params: params });
  }

  removeAuditSurveyReports(params: any) {
    return this.http.delete('/api/audit_survey_report/', { params: params });
  }

  getAuditSurveyReport(id: number) {
    return this.http.get(`/api/audit_survey_report/${id}/`);
  }

  createAuditSurveyReport(data) {
    return this.http.post('/api/audit_survey_report/', data);
  }

  // TODO - remove
  findAdminVehicles(pageSize = 5,
    page = 0,
    ordering: string,
    search = ''): Observable<VehicleCheckReportPaginationApi> {
    const _params = '?pageSize=' + pageSize.toString() + '&page=' + (page + 1).toString()
      + '&ordering=' + ordering + '&search=' + search;
    return this.http.get<VehicleCheckReportPaginationApi>('/api/administration/vehicles/' + _params
    ).pipe(
      map(res => res)
    );
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/reports.service.ts